import { apiService } from '../services/apiService';

const getWorkplaceId = (): number => {
	const id = localStorage.getItem('workplace-id');
	return id ? Number(id) : 1;
};

export type ToDoScheduleAssignmentType = 'person' | 'group';

export interface IToDoSchedulePost {
	description: string;
	note: string;
	priority: string;
	category: string;
	workplace: string;
	assignmentType: ToDoScheduleAssignmentType;
	assignee?: string | null;
	group?: string | null;
	checklistFrequency: string;
	dailyTimes?: string[] | null;
	weeklyTimes?: Record<string, string[]> | null;
	weekdayTimes?: string[] | null;
	monthlyScheduleType?: string | null;
	monthlyScheduleSpecificDates?: Array<{ date: string; times: string[] }> | null;
	monthlyScheduleRecurringDays?: Array<{ recurring: number; day: string; times: string[] }> | null;
	annualDate?: string | null;
	annualTime?: string | null;
	pastDueAfterDay?: number;
	pastDueAfterHour?: string;
}

export const createToDoSchedule = async (body: Partial<IToDoSchedulePost>): Promise<unknown> => {
	const workplaceId = getWorkplaceId();
	const payload: Partial<IToDoSchedulePost> = {
		...body,
		workplace: body.workplace || `/api/workplaces/${workplaceId}`,
	};
	const { ...data } = apiService.responseHandler(await apiService.post('to_do_schedules', payload));
	return data;
};

export const getToDoSchedules = async (workplaceId?: number): Promise<unknown> => {
	const wp = workplaceId ?? getWorkplaceId();
	const query = `to_do_schedules?page=1&itemsPerPage=100&workplace=${wp}`;
	const { ...data } = apiService.responseHandler(await apiService.get(query));
	return data;
};

export const getToDoScheduleById = async (id: number): Promise<unknown> => {
	const { ...data } = apiService.responseHandler(await apiService.get(`to_do_schedules/${id}`));
	return data;
};

export const updateToDoSchedule = async (
	id: number,
	body: Partial<IToDoSchedulePost>
): Promise<unknown> => {
	const { ...data } = apiService.responseHandler(await apiService.put(`to_do_schedules/${id}`, body));
	return data;
};

export const deactivateToDoSchedule = async (id: number): Promise<unknown> => {
	const { ...data } = apiService.responseHandler(
		await apiService.delete(`todo_schedules/deactive/${id}`)
	);
	return data;
};
